import { Dispatch } from "redux";
import { toggleEmployeeTable } from "../../../redux/employeetable/employeeTableAction";

export const FilterIcon = ({ filtered, columnTitle }: any) => (
  <div>
    {columnTitle === "Status" ? <span className="filter-dot filterStatus"></span> : filtered && <span className="filter-dot filterStatus"></span>}
    <span className="material-symbols-outlined expand-icon">expand_more</span>
  </div>
);
export const CustomExpandIcon = ({ expanded, onExpand, record }: any) => {
  if (!(record?.status !== "Probation Extension" && record?.status !== "Probation"))
    return expanded ? (
      <span className="material-symbols-outlined expand-icon" onClick={(e) => onExpand(record, e)}>
        expand_less
      </span>
    ) : (
      <span className="material-symbols-outlined expand-icon" onClick={(e) => onExpand(record, e)}>
        expand_more
      </span>
    );
};

export const getRowClassName = (record: any) => {
  return record.reviewStatus === "Pending" ? "highlighted-row" : "";
};

export const handelExpand = (dispatch: Dispatch, setIsExpand: (value: any) => void, setPaginationConfig: (value: any) => void) => {
  setIsExpand((prevExpand: boolean) => {
    const newExpandState = !prevExpand;

    setPaginationConfig((prevConfig: { pageSize: number }) => ({
      ...prevConfig,
      pageSize: newExpandState ? 10 : 15,
    }));

    dispatch(toggleEmployeeTable(newExpandState));
    return newExpandState;
  });
};